import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Pagination } from "semantic-ui-react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  UPDATE_PRODUCT_PACKAGE_PAGE_NUMBER,
  SG_GET_PRODUCT_PACKAGE,
  RESET_PRODUCT_PACKAGE,
} from "constants/actions";

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let ReloadPage = searchParams.get("reload");

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(1);

  const { get_product_package } = useSelector(
    (state) => ({
      get_product_package: state.product_package.product_package,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch({
      type: RESET_PRODUCT_PACKAGE,
    });
    dispatch({
      type: SG_GET_PRODUCT_PACKAGE,
    });
  }, [dispatch]);

  useEffect(() => {
    setResults(get_product_package?.results);
    setPage(get_product_package?.pageNumber);
    setTotalPages(
      Math.ceil(get_product_package?.count / get_product_package?.page_size)
    );
    if (get_product_package?.count % get_product_package?.page_size) {
      setTotalPages(
        Math.ceil(get_product_package?.count / get_product_package?.page_size)
      );
    }
  }, [get_product_package, page, ReloadPage]);

  function handlePageChange(e, { activePage }) {
    setPage(activePage);
    dispatch({
      type: UPDATE_PRODUCT_PACKAGE_PAGE_NUMBER,
      payload: activePage,
    });
    dispatch({
      type: SG_GET_PRODUCT_PACKAGE,
      payload: `page=${activePage}`
    });
  }

  function EditTemplate(templateId) {
    navigate(`/app/product/package/edit/${templateId}`);
  }

  function TemplateDetails(templateId) {
    navigate(`/app/product/package/details/${templateId}`);
  }

  return (
    <>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Order</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {results &&
              results.map((product, index) => (
                <tr key={index}>
                  <td>{product.name}</td>
                  <td>{product.sort_order}</td>
                  <td>
                    <Clickable onClick={() => EditTemplate(product?.id)}>
                      Edit{" "}
                    </Clickable>{" "}
                    |
                    <Clickable onClick={() => TemplateDetails(product.id)}>
                      Details{" "}
                    </Clickable>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>

      <Pagination
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        activePage={page}
        totalPages={totalPages ? totalPages : 0}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default List;

const TableContainer = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f4f4f4;
  }
`;

const Clickable = styled.span`
  color: blue;
  cursor: pointer;
  &:hover {
    color: red;
  }
`;
